import { render, staticRenderFns } from "./OrgProfile.vue?vue&type=template&id=c15ee9da&"
import script from "./OrgProfile.vue?vue&type=script&lang=js&"
export * from "./OrgProfile.vue?vue&type=script&lang=js&"
import style0 from "./OrgProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports